import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useFlag } from '@unleash/proxy-client-react';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';

import ClientSearch from 'components/Shared/ClientSearch';
import PieceGestionSearch from 'components/Shared/PieceGestionSearch';
import CommandeGestionSearch from 'components/Shared/CommandeGestionSearch';
import RecentGestionList from 'components/Shared/CommandeGestionSearch/RecentGestionList';
import InfosPiece from './InfosPiece';
import DossiersPiece from './DossiersPiece';


// Composant fonctionnel pour utiliser le hook useFlag
const InformationsPage = ({
    namespace,
    onSelectPiece,
    onChangeClient,
    onClickCreate,
    initialNumeroPiece = ''
}) => {

    const [tabIndex, setTabIndex] = useState(0);
    const [client, setClient] = useState({
        id: 0,
        code: '',
        libelle: ''
    });
    const [numeroPiece, setNumeroPiece] = useState('');
    const [piece, setPiece] = useState(null);
    const [selectedKey, setSelectedKey] = useState('');

    const handleChangeClient = (newClient) => {
        // Au changement de client, on réinitialise les pièces et on efface la partie des infos logistique.
        setClient({ ...newClient });
        setNumeroPiece('');
        setPiece(null);

        onChangeClient();
    };

    const handleSearch = () => {
        setNumeroPiece('');
        setPiece(null);
    };

    const handleSelectPiece = (newNumeroPiece, newPiece) => {
        setNumeroPiece(newNumeroPiece);
        setPiece(newPiece);

        // Clé technique pour l'API (BL ou DT) — fallback sur numeroPiece pour le legacy
        const cleApi = newPiece?.bonLivraisonGestionCle || newPiece?.demandeTransfertGestionCle || newNumeroPiece;
        onSelectPiece(cleApi);
    };


    const handleTabChange = (_event, newValue) => {
        setTabIndex(newValue);
        // Reset les résultats lors du changement d'onglet
        setNumeroPiece('');
        setPiece(null);
        setSelectedKey('');
    };

    const handleSelectKey = (key) => {
        // Coller la clé et basculer vers l'onglet recherche commande
        setSelectedKey(key);
        setTabIndex(1);
    };

    return (
        <>
            <Card sx={{ overflow: 'visible', m: 2 }}>
                <CardContent>
                    <Grid item xs={8}>
                        <Grid item xs={12}>
                            <ClientSearch
                                namespace={namespace}
                                onChange={handleChangeClient}
                                isRequired={false}
                                client={client}
                            />
                        </Grid>
                    </Grid>


                    <Grid item xs={12}>
                        <PieceGestionSearch
                            namespace={namespace}
                            onSelectPiece={handleSelectPiece}
                            onSearch={handleSearch}
                            client={client}
                            withLignes={false}
                            high
                            warningReclamation={false}
                            defautProduitInfos={false}
                            logistiqueInfos={false}
                            cacherTableResultat={true}
                            defautNumeroPiece={numeroPiece ? '' : initialNumeroPiece}
                            autoriserToutePieceDuJour={true}
                        />
                    </Grid>

                </CardContent>
            </Card>

            {/* Résultats pour la recherche de pièce */}
            { piece && (
                <DossiersPiece piece={piece} onClickCreate={onClickCreate} />
            )}

            { piece && (
                <InfosPiece piece={piece} />
            )}
        </>
    );
};

InformationsPage.propTypes = {
    onSelectPiece: PropTypes.func.isRequired,
    onChangeClient: PropTypes.func.isRequired,
    onClickCreate: PropTypes.func.isRequired,
    namespace: PropTypes.string.isRequired,
    initialNumeroPiece: PropTypes.string
};

// Valeur par défaut pour initialNumeroPiece
InformationsPage.defaultProps = {
    initialNumeroPiece: ''
};

export default InformationsPage;
